import { render } from "./ConfigComponents.vue?vue&type=template&id=4e8a935e&scoped=true&ts=true"
import script from "./ConfigComponents.vue?vue&type=script&lang=ts"
export * from "./ConfigComponents.vue?vue&type=script&lang=ts"

import "./ConfigComponents.vue?vue&type=style&index=0&id=4e8a935e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e8a935e"]])

export default __exports__